import useCarBrandDelete from 'api/carBrand/useCarBrandDelete/useCarBrandDelete';
import useCarBrandList from 'api/carBrand/useCarBrandList/useCarBrandList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CarBrandEditModal from 'components/shared/Modals/carBrand/CarBrandEditModal/CarBrandEditModal';
import CarBrandInsertModal from 'components/shared/Modals/carBrand/CarBrandInsertModal/CarBrandInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCarBrandTableColumns from 'hooks/carBrand/useCarBrandTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CarBrand = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCarBrandList, loading, carBrandList, pageRef] =
    useCarBrandList(guid);

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCarBrand, setEditChosenCarBrand] = useState({});

  const [deleteRequest] = useCarBrandDelete();

  const navigate = useNavigate();
  const { can } = usePermissions();

  const brandPermissions =
    permissions.general.categories.globalSettings.coddingSettings.carFactory
      .brands;

  const canCreate = can(brandPermissions.create);
  const canEdit = can(brandPermissions.edit);
  const canDelete = can(brandPermissions.delete);
  const canDetail = can(brandPermissions.models.view);

  const tableRef = useRef(null);

  useEffect(() => {
    getCarBrandList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getCarBrandList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/carModel/${row.id}`),
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCarBrand(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useCarBrandTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getCarBrandList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCarBrandList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCarBrandList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(carBrandList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={carBrandList[page]}
          rows={carBrandList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت برند خودرو' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canCreate ? (
        <CarBrandInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCarBrandList={getCarBrandList}
          factoryGuid={guid}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <CarBrandEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenCarBrand={editChosenCarBrand}
          getCarBrandList={getCarBrandList}
        />
      ) : null}
    </>
  );
};

export default CarBrand;
